module.exports = __webpack_public_path__ + "images/59e6779c8758a3d6a82ca1d4f3882df5.svg";